import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const About = () => {
  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <section className="mx-auto flex max-w-[820px] flex-col gap-4 px-6 py-16 text-center">
        <h1 className="text-[44px] font-bold leading-tight tracking-[-1.5px] text-ink">
          About Klassekartgenerator
        </h1>
        <p className="mx-auto max-w-[520px] text-lg text-muted">
          A tool built by Magnus Heide AS to help teachers create fair, ready-to-print
          seating plans in under a minute.
        </p>
      </section>
      <Footer />
    </div>
  );
};

export default About;
